import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { getAtlassianContextUrl } from '@atlassian/teams-common/context-config';
import ErrorImageSvg from '../../assets/error-page/svg-error-window_ptc.svg';
import * as Styled from './ErrorPage.styled';
export const DefaultErrorImage = /*#__PURE__*/React.createElement(Styled.ErrorImage, {
  src: ErrorImageSvg
});
export const ErrorPage = ({
  title,
  body,
  image,
  actions
}) => {
  return /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test-selector": "error-page"
  }, /*#__PURE__*/React.createElement(Styled.ImageOuter, null, image || DefaultErrorImage), /*#__PURE__*/React.createElement(Styled.ErrorTextContainer, null, /*#__PURE__*/React.createElement(Styled.TitleWrapper, null, /*#__PURE__*/React.createElement(Styled.Title, null, title)), body && /*#__PURE__*/React.createElement(Styled.DescriptionWrapper, null, /*#__PURE__*/React.createElement(Styled.Description, null, body))), actions && /*#__PURE__*/React.createElement(Styled.ButtonContainer, null, actions));
};
export const GenericErrorPage = props => {
  const actions = props.hasSupportLink && /*#__PURE__*/React.createElement(Button, {
    rel: "noopener noreferrer",
    target: "_blank",
    href: `${getAtlassianContextUrl('support')}/contact/#/`
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.contactUs));
  return /*#__PURE__*/React.createElement(ErrorPage, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, messages.title),
    body: /*#__PURE__*/React.createElement(FormattedMessage, messages.description),
    actions: actions || undefined
  });
};
const messages = defineMessages({
  title: {
    id: 'pf-home.generic-error-title',
    defaultMessage: 'Something went wrong'
  },
  contactUs: {
    id: 'ptc-directory.error-boundary.message-link-text',
    defaultMessage: 'Contact support',
    description: 'The text of the link leading to the Atlassian support website, shown below the error description on the error pages'
  },
  description: {
    id: 'pf-home.generic-error-description',
    defaultMessage: 'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things.'
  }
});
export default ErrorPage;